/** 五颗星,支持半颗 */
export function Rating({ value, count }: { value: number; count?: number }) {
  const stars = Array.from({ length: 5 }, (_, i) => (value >= i + 1 ? "full" : value > i ? "half" : "empty"));
  return (
    <span className="ui-rating" aria-label={`${value} 分`}>
      {stars.map((s, i) => (
        <svg key={i} viewBox="0 0 20 20" width="16" height="16" className={`ui-star ui-star-${s}`}>
          <defs>
            <linearGradient id={`half-${i}`}><stop offset="50%" stopColor="currentColor" /><stop offset="50%" stopColor="transparent" /></linearGradient>
          </defs>
          <path fill={s === "half" ? `url(#half-${i})` : s === "full" ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1"
            d="M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1.1 5.9L10 14.9l-5.3 2.8 1.1-5.9L1.5 7.7l5.9-.8z" />
        </svg>
      ))}
      <span className="ui-rating-value">{value.toFixed(1)}</span>
      {count !== undefined && <span className="ui-rating-count">{count} 条评价</span>}
    </span>
  );
}
